"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m7.72 17.7 3.47-1.53.81-.36.81.36 3.47 1.53L12 7.27z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m4.5 20.29.71.71L12 18l6.79 3 .71-.71L12 2zm8.31-4.12-.81-.36-.81.36-3.47 1.53L12 7.27l4.28 10.43z"
}, "1")], 'NavigationTwoTone');